import React, { useState, useEffect } from "react";
import Map from "../../components/Map/Map";
import EditListing from "../../components/EditListing/EditListing";
import "./EditListingPage.scss";
import axios from "axios";

export default function EditListingPage(props) {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [currentInput, setInput] = useState({});
  const [currentLocation, setLocation] = useState({});
  useEffect(() => {
    axios
      .get(REACT_APP_API_ENDPOINT + "/" + props.match.params.id)
      .then((res) => {
        setInput(res.data);
        setLocation({
          lat: Number(res.data.lat),
          lng: Number(res.data.lng),
        });
      });
  }, []);
  return (
    <div className="edit">
      <div className="edit__wrap">
        <Map currentLocation={currentLocation} setLocation={setLocation} />
        <div className="edit__content">
          <EditListing
            currentLocation={currentLocation}
            setLocation={setLocation}
            data={currentInput}
            setInput={setInput}
          />
        </div>
      </div>
    </div>
  );
}
